import React from 'react';
import { Text, i18n, localizationMaps, tokens } from '@simplybenefits/sb-ui-library';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import { helpers } from '@simplybenefits/sb-utils';

/**
 * 
 * @param {*} ltd 
 * @returns 
 */
const createGradedLTDCoverage = (ltd) => {
    let ltdStr = i18n.t(tokens.labels.coverage.gradedScaleAsFollows, { percentageFirstMax: ltd.percentageFirstMax, firstMax: ltd.firstMax });

    if (ltd.percentageSecondMax && ltd.secondMax === 0) {
        ltdStr += i18n.t(tokens.labels.coverage.percentageSecondMaxOfRemainder, { percentageSecondMax: ltd.percentageSecondMax });
        return ltdStr;
    }

    if (ltd.percentageSecondMax && ltd.secondMax > 0) {
        ltdStr += i18n.t(tokens.labels.coverage.percentageSecondMaxOfNextSecondMax, { percentageSecondMax: ltd.percentageSecondMax, secondMax: helpers.numberWithCommas(ltd.secondMax) });
    }

    if (ltd.percentageThirdMax) {
        const thirdMaxStr = ltd.thirdMax > 0 ? i18n.t(tokens.labels.coverage.ofTheNext) : i18n.t(tokens.labels.coverage.theRemainder);
        const thirdMaxValue = ltd.thirdMax ? helpers.numberWithCommas(ltd.thirdMax) : '';
        ltdStr += i18n.t(tokens.labels.coverage.percentageThirdMaxOfThirdMax, { percentageThirdMax: ltd.percentageThirdMax, thirdMaxStr, thirdMaxValue });
        return ltdStr;
    }

    return ltdStr;
};

/**
 *
 * @param {*} props
 */
export default function Ltd ({ classes, expanded, ltd, handleChange, isStudent }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('ltd')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('ltd') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.longTermDisability) }</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        ltd.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                                </Text>
                            </div>
                            : null
                    }

                    {
                        ltd.isGraded ?
                            <>
                                <Text small bold margin="20px 0px 0px 0px">{createGradedLTDCoverage(ltd)}</Text>
                                <Text small bold margin="0px 0px 20px 0px">{ ltd.isTaxable ? i18n.t(tokens.labels.coverage.taxable) : i18n.t(tokens.labels.coverage.nonTaxable) }</Text>
                            </>
                            :
                            <>
                                <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.flatAmount, { percentageOfFlatAmount: ltd.percentageOfFlatAmount }) }</Text>
                                <Text small bold margin="0px 0px 20px 0px">{ ltd.isTaxable ? i18n.t(tokens.labels.coverage.taxable) : i18n.t(tokens.labels.coverage.nonTaxable) }</Text>
                            </>
                    }

                    <div>
                        
                        { 
                            ltd.maxEvidence > 0 ?
                                <Text small margin="10px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.maxEvidenceLabel, { maxEvidence: helpers.numberWithCommas(ltd.maxEvidence) }) }
                                </Text>
                                :
                                null
                        }

                        { 
                            ltd.maxNoEvidence > 0 ?
                                <Text small margin="10px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.maxNoEvidenceLabel, { maxNoEvidence: ltd.maxNoEvidence }) }
                                </Text>
                                :
                                null
                        }

                        <Text small margin="5px 0px 0px 0px">
                            { i18n.t(tokens.labels.coverage.dayEliminationPeriod, { elimPeriod: parseInt(ltd.elimPeriod, 10) }) }
                        </Text>

                        {
                            ltd.benefitsPeriod ? 
                                <Text small margin="5px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.benefitsPeriod, { benefitsPeriod: localizationMaps.fromEnglish("benefitsPeriod", ltd.benefitsPeriod) })}
                                </Text>
                                : 
                                null 
                        }
                        {
                            ltd.defOfDisability ?
                                <Text small margin="5px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.definitionOfDisability, { defOfDisability: localizationMaps.fromEnglish("defOfDisability", ltd.defOfDisability) })}
                                </Text>
                                :
                                null
                        }

                        { 
                            ltd.includeCostOfLivingAdjustments && ltd.costOfLivingAdjustmentsPercentage ?
                                <Text small margin="5px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.costOfLivingAdjToDisability, { costOfLivingAdjustmentsPercentage: ltd.costOfLivingAdjustmentsPercentage }) }
                                </Text>
                                :
                                null
                        }

                        { 
                            ltd.includeAllowPreExistingConditions ?
                                <Text small margin="5px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.allowPreexistingConditions) }
                                </Text>
                                :
                                null
                        }

                        { 
                            ltd.includeLumpSumPaymentDisabledParticipantsDeath ?
                                <Text small margin="5px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.lumpSumPayment) }
                                </Text>
                                :
                                null
                        }

                        {
                            isStudent ?
                                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtEndOfStudy, { terminationAge: ltd.terminationAge }) }</Text>
                                :
                                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: ltd.terminationAge }) }</Text>}
                    </div>

                </AccordionDetails>
            </Accordion>
        </div>
    );
}